import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BUSNCommunicationService } from 'libs/svcs-core-business/src/lib/services/busn-communication.service';

@Component({
  selector: 'schedules-remove-asset-fail',
  standalone: false,
  templateUrl: './schedules-remove-asset-fail.component.html',
  styleUrls: ['./schedules-remove-asset-fail.component.scss']
})
export class SchedulesRemoveAssetFailComponent implements OnInit {
  @Output() navigateClose: EventEmitter<unknown> = new EventEmitter();
  showLottie = true;
  constructor(private readonly busnCommService: BUSNCommunicationService) { }

  ngOnInit(): void {
  }

  dismiss() {
    this.navigateClose.emit();
  }

  showIntercom() {
    this.busnCommService.openContactCardPopup()
  }

}
